import { useSuspenseQuery } from '@tanstack/react-query';
import { SourcingService } from 'api-clients/monolith';
import { useEffect } from 'react';

import { useJobPostingContext } from '@/contexts/job-posting-context';
import { queryKeys } from '@/query-keys';

import { Card } from './card';

interface SourcingRecommendationProps {
  isExpanded: boolean;
  onCountChange: (count: number) => void;
}

export function SourcingRecommendation({
  isExpanded,
  onCountChange,
}: SourcingRecommendationProps) {
  const { setSelectedOpeningIds, setOpenChannelsDialog } =
    useJobPostingContext();

  const {
    data: { opening_ids: suggestedOpeningIds },
  } = useSuspenseQuery({
    queryKey: [...queryKeys.dashboard.recommendations.sourcing],
    queryFn: () =>
      SourcingService.getInternalApiSourcingDashboardSourcingRecommendation(),
  });

  const hasRecommendations =
    !!suggestedOpeningIds && suggestedOpeningIds.length > 0;

  useEffect(() => {
    onCountChange(hasRecommendations ? 1 : 0);
  }, [hasRecommendations, onCountChange]);

  if (!isExpanded || !hasRecommendations) return null;

  const handlePostJobClick = () => {
    setSelectedOpeningIds(suggestedOpeningIds);
    setOpenChannelsDialog(true);
  };

  return (
    <Card
      recommendationType="sourcing"
      onClick={handlePostJobClick}
      value={suggestedOpeningIds.length}
    />
  );
}
